import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { $locale, setLocale } from './state/locale';
import './state/visitedSights';
import './state/sceneOpen';
import { ViewportProvider } from './context/ViewportContext';
import { initAmplitude } from './analytics/amplitude';
import { startSessionTracking } from './analytics/sessionTracker';
import { startSceneTracking } from './analytics/sceneTracker';
import { startTourTracking } from './analytics/tourTracker';
import { startPerformanceTracking } from './analytics/performanceTracker';
import { startAssistantTracking } from './analytics/assistantTracker';
import { startNavigationTracking } from './analytics/navigationTracker';
import { startProgressTracking } from './analytics/progressTracker';
import { startChatStateTracking } from './analytics/chatStateTracker';
import { startPhotoTracking } from './analytics/photoTracker';
import { startCameraSessionTracking } from './analytics/cameraSessionTracker';
import { startOverallTracking } from './analytics/overallTracker';
import { MobilePreviewFrame } from './components/MobilePreviewFrame/MobilePreviewFrame';
import { installViewportMetricsSync } from './utils/visualViewportMetrics';
import './theme/applyTheme';
import './theme/themes.css';
import './main.css';

initAmplitude();
startSessionTracking();
startSceneTracking();
startTourTracking();
startPerformanceTracking();
startAssistantTracking();
startNavigationTracking();
startProgressTracking();
startChatStateTracking();
startPhotoTracking();
startCameraSessionTracking();
startOverallTracking();

// NOTE: scene mounting is driven by App.tsx via `buildStackFromPath()` →
// `rebuildStack` → `setSceneId` on initial render. A previous direct
// `setSceneId(...)` call lived here with a duplicate SCENE_POI_ID map —
// removed to keep navigation single-sourced and to avoid firing
// `scene_open` twice on initial load (once from this module, once from
// the App effect).
setLocale($locale.getState());

const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Root element "#app" was not found');
}

installViewportMetricsSync();

ReactDOM.createRoot(rootElement).render(
  <MobilePreviewFrame>
    <ViewportProvider>
      <App />
    </ViewportProvider>
  </MobilePreviewFrame>
);
